module.exports = __webpack_public_path__ + "img/icon_dashboard.76f0f995.svg";